import { getStaffSessionToken } from '../auth/staffSession';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authSelector } from '../auth/state/authSlice';

/** Existing team login; the frame never receives AWS keys or customer credentials. */
export const CameraMigrations = ({ installation = false, diagnostics = false }: { installation?: boolean; diagnostics?: boolean }) => {
  const { token, isAdmin } = useSelector(authSelector);
  const navigate = useNavigate(), location = useLocation();
  const frame = useRef<HTMLIFrameElement>(null);
  const basePath = diagnostics ? '/team/camera-diagnostics' : installation ? '/team/migrations/install' : '/team/migrations';
  const jobKey = diagnostics ? 'session' : installation ? 'job' : 'check';
  const initialJob = useRef(new URLSearchParams(location.search).get(jobKey));
  const source = (diagnostics ? '/camera-migration/night.html' : installation ? '/camera-migration/index.html' : '/camera-migration/readiness.html') + (/^[a-f0-9]{32}$/.test(initialJob.current || '') ? '?' + jobKey + '=' + initialJob.current : '');
  useEffect(() => {
    if (!token || !isAdmin) navigate('/team-login?next=' + encodeURIComponent(basePath + location.search), { replace: true });
  }, [token, isAdmin, navigate, location.search, basePath]);
  useEffect(() => {
    const sendSession = () => frame.current?.contentWindow?.postMessage({type:'farmstream-migration-session',token: getStaffSessionToken(),
      apiOrigin:window.location.origin}, window.location.origin);
    const message = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return;
      if (event.data?.type === 'farmstream-migration-ready') sendSession();
      if (event.data?.type === (diagnostics ? 'farmstream-migration-session-id' : installation ? 'farmstream-migration-job' : 'farmstream-migration-check')) {
        const id=event.data.jobId;
        if (id === null || (typeof id === 'string' && /^[a-f0-9]{32}$/.test(id))) navigate(basePath + (id ? '?'+jobKey+'='+id : ''), {replace:true});
      }
      if (event.data?.type === 'farmstream-migration-auth-required') navigate('/team-login?next=' + encodeURIComponent(basePath + window.location.search), {replace:true});
    };
    window.addEventListener('message',message);sendSession();
    return () => window.removeEventListener('message',message);
  }, [token,navigate,installation,diagnostics,basePath,jobKey]);
  if (!token || !isAdmin) return <p>Opening team sign-in…</p>;
  return <main style={{background:'#f3f8fa',minHeight:'100vh'}}>
    <nav aria-label="Team navigation" style={{padding:'16px 24px',display:'flex',gap:24,flexWrap:'wrap'}}>
      <Link to="/admin/select-user">Team home</Link><Link to="/tools">Camera tools</Link><Link to="/team/camera-diagnostics">Night image diagnostics</Link><Link to="/team/migrations">Camera checks</Link><Link to="/team/migrations/install">Installation queue</Link>
    </nav>
    <iframe ref={frame} src={source} title={diagnostics ? "Night image diagnostics" : "Farmstream camera migrations"} sandbox="allow-scripts allow-same-origin allow-forms"
      style={{width:'100%',height:'calc(100vh - 64px)',minHeight:700,border:0}} />
  </main>;
};
